import {localization} from "@/common/lang/localization";

function validateRequiredFields(form, validations) {
    let isValid = true;

    for (let field in form) {
        let validation = validations[field];

        if (!form.hasOwnProperty(field) || !validations.hasOwnProperty(field) || !(validation.required || validation.checked || validation.requiredProperty)) {
            continue;
        }

        let value = form[field];

        if (validation.required) {
            isValid &= validateRequiredValue(value);
        }

        if (validation.checked) {
            isValid &= validateCheckedValue(value);
        }

        if (validation.requiredProperty) {
            isValid &= validateRequiredProperty(value, validation.requiredProperty.name);
        }
    }

    return isValid;
}

function validateForm(self, validator, ignoreFields) {
    return new Promise((resolve, reject) => {
        self.$nextTick(() => {
            let fieldsFilter = undefined;
            if (ignoreFields) {
                fieldsFilter = validator.fields.items.filter(item => !ignoreFields.includes(item.name));
            }

            validator.validateAll(fieldsFilter).then(valid => {
                if (valid) {
                    resolve();
                } else {
                    reject(localization.i18n.t("common.validation.form.hasErrors"));
                }
            });
        });
    });
}

// Required validation check matches vee-validate rule required
function validateRequiredValue(value) {
    let isValid = true;

    if (value === undefined || // value is undefined
        value === null || // value is null
        String(value).trim().length === 0 || // value is empty string
        (value instanceof Array && value.length === 0)) // value is empty array
    {
        isValid &= false;
    }

    return isValid;
}

function validateRequiredProperty(value, requiredPropertyKey) {
    return typeof value === "object" && value.hasOwnProperty(requiredPropertyKey) && !!value[requiredPropertyKey];
}

function validateCheckedValue(value) {
    return !((typeof value === "boolean" && value === false) || (typeof value === "number" && value <= 0));
}

export {
    validateRequiredFields,
    validateForm,
    validateRequiredValue,
    validateRequiredProperty,
    validateCheckedValue
}